const DATA = {
    HEADER_HEIGHT: {
        MOBILE: '15vw',
        STATIC: '4vw',
    },
    FOOTER_HEIGHT: {
        MOBILE: '120vw',
        STATIC: '30vw',
    },
    SCREEN: {
        BREAKPOINT: {
            SM: 576,
            MD: 768,
            LG: 992,
            XL: 1200,
        },
    },
    COLOR: {
        NAV: '#FFFFFF',
        BG: '#FFFFFF',
        TEXT: '#444444',
        LOGO: {
            NUMBER: '#0081CC',
            NUMBER_DARKER_30: '#005A8f',
        },
        THEME: '#0E2A36',
        THEME_DARKER_30: '#0E2A36',
        THEME_DARKER_50: '#0E2A36',
        THEME_DARK: '#0E2A36',
        THEME_LIGHT: '#415D69',
        THEME_SECONDARY: '#898B8E',
        CREAM: '#F8F6F4',
        PHONE: '#E93429',
    },
    PHONE: '1566-6942',
};

export default DATA;
